export const BannerSkeleton = () => (
  <section className="banner padding-top--style2">
    <div className="container">
      <div className="col-12">
        <style>{`
          @keyframes skeleton-loading {
            0% { background-position: 100% 0; }
            100% { background-position: -100% 0; }
          }
          .banner-skeleton {
            width: 100%;
            border-radius: 12px;
            background: linear-gradient(90deg, #f3f3f3 25%, #e0e0e0 37%, #f3f3f3 63%);
            background-size: 400% 100%;
            animation: skeleton-loading 1.4s ease infinite;
            /* Default desktop aspect ratio */
            aspect-ratio: 1920 / 600;
          }
          
          /* For tablets and smaller laptops */
          @media (max-width: 991px) { 
            .banner-skeleton { 
              aspect-ratio: 2 / 1; /* A good ratio for tablets */
            } 
          }

          /* For mobile phones - THIS IS THE CHANGED PART */
          @media (max-width: 575px) { 
            .banner-skeleton { 
              aspect-ratio: 16 /9; /* Makes the banner shorter on mobile */
            } 
          }
        `}</style>
        <div className="banner-skeleton" />
      </div>
    </div>
  </section>
);
